const StrokeTopIcon = /*#__PURE__*/ [
  ["path", { d: "M19 7V15C19 17.8284 19 19.2426 18.1213 20.1213C17.2426 21 15.8284 21 13 21L11 21C8.17157 21 6.75736 21 5.87868 20.1213C5 19.2426 5 17.8284 5 15V7", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M21 2.99805L3 2.99805", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export { StrokeTopIcon as default };
//# sourceMappingURL=StrokeTopIcon.js.map
